import { render, staticRenderFns } from "./libelle-dates-livraison.vue?vue&type=template&id=5e6df9f4&scoped=true&"
import script from "./libelle-dates-livraison.vue?vue&type=script&lang=js&"
export * from "./libelle-dates-livraison.vue?vue&type=script&lang=js&"
import style0 from "./libelle-dates-livraison.vue?vue&type=style&index=0&id=5e6df9f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6df9f4",
  null
  
)

export default component.exports